import { useField } from 'formik'
import { useHoneypotDetection } from '@lib/hooks/use-honeypot-detection'

/**
 * This is a honeypot field that is used to prevent bots from submitting forms.
 * It is a hidden input field that is not visible to the user.
 * If the field is filled, the form validation will fail and prevent submission.
 *
 * IMPORTANT: The current input field on all forms is: 'website'
 */
export function HoneypotField() {
  const honeypotName = 'website'
  const [fieldProps, meta, helpers] = useField(honeypotName)

  const inputRef = useHoneypotDetection({
    currentValue: meta.value,
    setValue: helpers.setValue,
  })

  return (
    <input
      {...fieldProps}
      ref={inputRef}
      name={honeypotName}
      type="text"
      autoComplete="off"
      tabIndex={-1}
      style={{
        position: 'absolute',
        left: '-9999px',
        top: '-9999px',
        width: '1px',
        height: '1px',
        opacity: 0,
        pointerEvents: 'none',
        zIndex: -1,
      }}
    />
  )
}
